import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-trjlight">
        <div className="h-10 w-10 rounded-full border-2 border-navy/20 border-t-navy animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (requireAdmin) {
    const ok = user.roles && (user.roles.includes('super_admin') || user.roles.includes('registrar') || user.roles.includes('billing') || user.roles.includes('support') || user.roles.includes('instructor') || user.roles.includes('faculty'));
    if (!ok) return <Navigate to="/dashboard" replace />;
  }
  return children;
}
